module.exports = __webpack_public_path__ + "static/media/guitar.716c86e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guitar.png
// module id = 493
// module chunks = 2